import React from 'react';
import { connect } from 'react-redux';
import { Switcher } from 'ctia-ui';
import { getRequestTypeTitle } from 'helpers/RequestHelper';
import { toggleEditMode } from 'actions/user';

const RequestPageTitle = ({ request, user, toggleEditMode }) => {
  const { tn, type } = request;
  const typeTitle = getRequestTypeTitle(type);

  return (
    <div style={{ paddingBottom: 15 }}>
      <h1>{`${typeTitle} ${tn}`}</h1>
      <Switcher
        show={user.ctiaStaff}
        labelText="Enable Modify Mode"
        onChange={toggleEditMode}
        disabled={!request.isValid}
        checked={user.canEditRequest}
        showWarning={!request.isValid}
      />
    </div>
  );
};

function mapStateToProps({ request, user }) {
  return { request, user };
}

export default connect(
  mapStateToProps,
  { toggleEditMode }
)(RequestPageTitle);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/RequestPageTitle.js